import { useState } from "react"
import { Link } from "react-router-dom"
import {
  IconAlertCircle,
  IconArrowLeft,
} from "../../components/utils/Icons/CustomIcons"
import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import AddInvitationFrom from "./addInvitation/addInvitationFrom"
import ChooseType from "./chooseType"
import AddNames from "./addName"
import AddGuest from "./addGuests"
import { useInviteContext } from "./context"

const AddInvite = () => {
  const { t } = useTranslation()
  const [activePage, setActivePage] = useState<string>("addInvitation")
  const [addInviteDate, setAddInviteDate] = useState<any>(null)
  const [chooseTypeData, setChooseTypeDate] = useState<any>(null)
  const [addNamesData, setAddNamesData] = useState<any>(null)
  const { addInviteData, setAddInviteData } = useInviteContext()

  return (
    <div className="container">
      <div className="row d-flex flex-column flex-md-row  gap-2">
        {/* <div
          className="col-0 col-md-1"
        >
        </div> */}
        <div
          className="col-12 col-md-12 p-0"
          // style={{ backgroundColor: "red" }}
        >
          {activePage == "addInvitation" && (
            <AddInvitationFrom setActivePage={setActivePage} />
          )}
          {activePage == "chooseType" && (
            <ChooseType setActivePage={setActivePage} />
          )}
          {activePage == "addNames" && (
            <AddNames setActivePage={setActivePage} />
          )}
        </div>
      </div>
    </div>
  )
}

export default AddInvite
